/* PDP post-paint touches that genuinely cannot be done in Liquid.

   As of the 2026-07-27 server-side render pass, the buy-box sidebar,
   "About this item" highlights, units-sold social proof, the trust
   block, and the brand/rating row are ALL rendered in their final
   position directly by sections/main-product.liquid. That eliminated
   the post-paint DOM relocation that caused the load-time layout shift
   (lab CLS ~0.34 desktop / ~1.2 mobile) — and with it the head reveal
   gate (.llm-reflow-ready) those moves used to require. Nothing above
   the fold moves after first paint anymore.

   What remains here is only work that has no Liquid equivalent and does
   NOT shift the above-the-fold layout:
     1) "Best Seller" label → absolute overlay badge on the main image
        (starts display:none in the buy box, lands as an absolute badge,
        so it reserves/moves no layout space either way).
     2) "Key Features" accordion → pulled up out of the description
        (below the fold) into a full-width row under the product columns.
     3) A small cart icon prepended into the stock Add to Cart button.
*/
document.addEventListener('DOMContentLoaded', function () {
  const media = document.querySelector('.product-media');
  if (!media) return;

  /* 1) Best Seller badge overlays the main image VIEWER (not the whole
     .product-media column, which also holds the thumbnail rail). The
     label block is display:none in the buy box (llm-product-gallery-v2.css)
     until moved here, so it never flashes in its original spot. */
  const viewer = document.querySelector('.media-gallery__viewer');
  const labelContainer = document.querySelector('.product-label-container');
  const labelBlock = labelContainer ? labelContainer.closest('.product-info__block') : null;
  if (labelBlock && viewer) {
    labelBlock.classList.add('llm-media-badge');
    viewer.appendChild(labelBlock);
    /* classList reveal (not clearing an inline style) is what actually
       beats the stylesheet's display:none — see .llm-fouc-revealed. */
    labelBlock.classList.add('llm-fouc-revealed');
  }

  /* 2) Lift the "Key Features" accordion up out of the description
     (below the fold) into .product (the grid container, parent of media
     + info) as a full-width row below both columns. Sourced from the
     description accordions; "About this item" stays where it is. */
  var kfAccordion = null;
  var accordions = document.querySelectorAll('.llm-product-description__side .llm-pd-accordion');
  for (var i = 0; i < accordions.length; i += 1) {
    var kfHdr = accordions[i].querySelector('.llm-pd-accordion__header');
    if (kfHdr && /key features/i.test(kfHdr.textContent)) { kfAccordion = accordions[i]; break; }
  }
  if (kfAccordion) {
    kfAccordion.classList.add('llm-kf-in-media');
    (media.parentElement || media).appendChild(kfAccordion);

    /* "Show all N features" for the mobile clamp (.llm-kf-in-media li:nth-child(n+3) in
       llm-product-description.css). Built for every width — the button is display:none above 749px,
       so there is no resize listener to get wrong and no desktop side effect. Only worth adding when
       something is actually hidden, hence the >2 check. */
    var kfList = kfAccordion.querySelector('.llm-product-meta__features ul');
    var kfItems = kfList ? kfList.children.length : 0;
    if (kfItems > 2 && !kfAccordion.querySelector('.llm-kf-toggle')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'llm-kf-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Show all ' + kfItems + ' features';
      btn.addEventListener('click', function () {
        var open = kfAccordion.classList.toggle('llm-kf--expanded');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show fewer features' : 'Show all ' + kfItems + ' features';
      });
      kfList.parentElement.appendChild(btn);
    }
  }

  /* 2b) MOBILE: lift the rankings out of the white accordion card.
     Liquid renders them in the Product Details column, which is right on desktop. On mobile that
     column collapses into the white card and the ranks end up buried between accordions; the owner
     wants them above the card, in the gap between Frequently-Bought-Together and the card itself.
     Different parents, so CSS order can't do it — hence a real move, reversed on resize back to
     desktop rather than left stranded.

     ⚠️ Do NOT add `container` here to line it up with the card below. A theme rule
     (`.cc-main-product > .container:not(.product-breadcrumbs), …`) paints every .container on the
     product page as a white card with 13px/15px padding, so the class silently gave the rankings a
     card background the owner did not want. The alignment is done in CSS instead. */
  var ranks = document.querySelector('.llm-rankings-block');
  var descGrid = document.querySelector('.llm-product-description__grid');
  if (ranks && descGrid && descGrid.parentElement) {
    var ranksHome = ranks.parentElement;
    var ranksNext = ranks.nextElementSibling;          // exact slot to restore into
    var mqNarrow = window.matchMedia('(max-width: 749px)');
    var placeRanks = function () {
      if (mqNarrow.matches) {
        if (ranks.nextElementSibling !== descGrid) {
          ranks.classList.add('llm-rankings-block--above-card');
          descGrid.parentElement.insertBefore(ranks, descGrid);
        }
      } else if (ranks.parentElement !== ranksHome) {
        ranks.classList.remove('container', 'llm-rankings-block--above-card');
        ranksHome.insertBefore(ranks, ranksNext);
      }
    };
    placeRanks();
    if (mqNarrow.addEventListener) mqNarrow.addEventListener('change', placeRanks);
    else if (mqNarrow.addListener) mqNarrow.addListener(placeRanks);   // older WebKit
  }

  /* 3) The Add-to-Cart cart icon is now rendered directly in the buy-buttons Liquid markup
     (sections/main-product.liquid), not injected here — a JS-appended icon was discarded on every
     variant-change re-render of the button. Left intentionally as markup so it always persists. */
});
